import React from 'react'
import PropTypes from 'prop-types'
import SeasonalLogoFrame from './seasonal-logo-frame'

/**
 * Layers a short seasonal particle animation over the logo (not a different
 * logo image). It plays on its own at most every 30 minutes per browser, and
 * again while the logo is hovered or tapped.
 *
 * Opt-in per brand via `enabled` (the logo config's `seasonalOverlay`). Brands
 * that do not opt in render only `children`.
 */
const SeasonalLogo = ({ enabled = false, now, children }) =>
  enabled ? (
    <SeasonalLogoFrame now={now}>{children}</SeasonalLogoFrame>
  ) : (
    children
  )

SeasonalLogo.propTypes = {
  enabled: PropTypes.bool,
  now: PropTypes.instanceOf(Date),
  children: PropTypes.node.isRequired,
}

export { getSeason, SEASONS } from './seasons'
export { resetAutoPlayDecision, clearAutoPlayHistory } from './auto-play'
export default SeasonalLogo
